import React from "react";

const PinnedIconNoOutline = ({ width, height, fill, fillBg }) => {
  return (
    // <svg
    //   width={width}
    //   height={height}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <circle cx="12" cy="12" r="12" fill={fillBg} />
    //   <path
    //     d="M14.5413 13L15.9663 14.0829V14.792H12.4255V18.2391L12 18.5937L11.5745 18.2391V14.792H8.03369V14.0829L9.37501 13V7.89663H8.488V7.1875H15.4283V7.89663H14.5413V13ZM9.18462 14.0829H14.7317L13.6904 13.2596V7.89663H10.226V13.2596L9.18462 14.0829Z"
    //     fill={fill}
    //   />
    // </svg>

    <svg
      width="13"
      height="19"
      viewBox="0 0 13 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4659 9.79998L12.7459 11.5327V12.6673H7.08055V18.1826L6.39979 18.7499L5.71903 18.1826V12.6673H0.0537109V11.5327L2.19982 9.79998V1.6346H0.780611V0.5H11.8851V1.6346H10.4659V9.79998ZM1.8952 11.5327H10.7706L9.10441 10.2154V1.6346H3.56134V10.2154L1.8952 11.5327Z"
        fill="black"
      />
    </svg>
  );
};

PinnedIconNoOutline.defaultProps = {
  width: 26,
  height: 26,
  fill: "white",
  fillBg: "#E31C79",
};

export default PinnedIconNoOutline;
